export default {"src":"/_next/static/media/from-scratch.83395674.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};